import React, {
	useEffect, useState
}from "react"
import {
	Input, Modal, Form, DatePicker, Select
}from "antd"
import moment from "moment"
import {
	reReportHierarchyActions
}from "../ReReportHierarchies/store/actions"
import {
	reReportKindActions
}from "../ReReportKinds/store/actions"
import 'antd/lib/date-picker/style/index.css'
import i18nGlobal from "../../../localization"
import i18n from "../localization"
import {
	useDispatch, useSelector
}from "react-redux"
import Notifications from "../../../helpers/Notifications"
import {
	CustomSelect
}from "../../../components/CustomSelect"
import {
	CustomInput
}from "../../../components/CustomInput"
import CustomButton from "../../../components/ButtonCustom"

const ReportCreateUpdateForm = (props) => {
	const dispatch = useDispatch()
	const isRu = useSelector(state => state.globalReducer.isRu)
	const { visible, setVisible, setRecord, record, create, update } = props
	const [form] = Form.useForm()
	const [values, setValues] = useState({})
	const { reportKinds } = useSelector((state) => state.reReportKindReducer)
	const { reportHierarchies } = useSelector((state) => state.reReportHierarchyReducer)
	const { isSending, reportChanged } = useSelector((state) => state.reReportReducer)

	useEffect(() => {
		if (reportChanged)
			handleCancel()
	}, [reportChanged])

	useEffect(() => {
		form.resetFields()
		if (record){
			form.setFieldsValue({
				code                : record.code?.trim(),
				name                : record.name?.trim(),
				nameBel             : record.nameBel?.trim(),
				reReportHierarchies : record.reReportHierarchies,
				reReportKind        : record.reReportKind,
				startDate           : (record.startDate === "0001-01-01T00:00:00" || record.startDate === null) ? null : moment(record.startDate)
			})
			setValues(form.getFieldsValue(["reReportKind", "reReportHierarchies"]))
		}
	}, [record])

	useEffect(() => {
		getReportKinds({
			isActual : true,
			name     : "",
			page     : 1,
			pageSize : 100
		})
		getReportHierarchies({
			isActual : true,
			name     : "",
			page     : 1,
			pageSize : 100
		})
	}, [])

	const getReportKinds = (params) => {
		dispatch(reReportKindActions.getAllPaged(params))
	}

	const getReportHierarchies = (params) => {
		dispatch(reReportHierarchyActions.getAllPaged(params))
	}

	function handleCancel(){
		form.resetFields()
		setVisible(false)
		setValues({})
		setRecord(null)
	}

	function handleChangeKind(id){
		const selectedKind = reportKinds?.items?.find((value) => {
			return value.id == id
		})
		form.setFieldsValue({
			reReportKind: selectedKind
		})
		setValues(form.getFieldsValue(["reReportKind", "reReportHierarchies"]))
	}

	function handleChangeHierarchies(ids){
		const selectedHierarchies = reportHierarchies?.items?.filter((value) => {
			return ids.indexOf(value.id) != -1
		})
		form.setFieldsValue({
			reReportHierarchies: selectedHierarchies
		})
		setValues(form.getFieldsValue(["reReportKind", "reReportHierarchies"]))
	}

	const onFinish = values => {
		const updateValues = {
			code              : values.code?.trim(),
			id                : record?.id,
			name              : values.name.trim(),
			nameBel           : values.nameBel.trim(),
			reportHierarchies : values.reReportHierarchies?.length ?
				values.reReportHierarchies.map((item) => {
					return item.id
				}).sort(function (first, second){
					return first - second
				})
				: [],
			reportKind : values.reReportKind.id,
			startDate  : new Date(values.startDate).toDateString()
		}
		const previousValues = {
			code              : record?.code?.trim(),
			id                : record?.id,
			name              : record?.name?.trim(),
			nameBel           : record?.nameBel?.trim(),
			reportHierarchies : record?.reReportHierarchies?.length ?
				record.reReportHierarchies.map((item) => {
					return item.id
				}).sort(function (first, second){
					return first - second
				})
				: [],
			reportKind : record?.reReportKind?.id,
			startDate  : record?.startDate ? new Date(record.startDate).toDateString() : null
		}
		if (JSON.stringify(updateValues) === JSON.stringify(previousValues))
			Notifications.errorNotice(i18n.messageDataNotChanged[isRu], null, 20)
		else
			updateValues.id ? update(updateValues) : create(updateValues)
	}

	return (
		<Modal
			destroyOnClose
			footer={ null }
			title={ record ? i18n.titleModalEditItem[isRu] : i18n.titleModalAddItem[isRu] }
			visible={ visible }
			width={ 800 }
			onCancel={ handleCancel }
		>
			<Form
				form={ form }
				labelAlign="left"
				labelCol={ { span: 6 } }
				name="nsi-form"
				wrapperCol={ { offset : 1,
					span   : 17 } }
				onFinish={ onFinish }
			>
				<Form.Item
					label={ i18n.tableHeaderView[isRu] }
					name="reReportKind"
					rules={ [{ required: true }] }
				>
					<>
						<CustomSelect
							allowClear
							showSearch
							defaultActiveFirstOption={ false }
							filterOption={ false }
							notFoundContent={ null }
							placeholder={ i18n.tableHeaderView[isRu] }
							showArrow={ false }
							value={ values?.reReportKind?.id }
							onChange={ handleChangeKind }
						>
							{ reportKinds?.items?.map((value) => {
								return (
									<Select.Option
										key={ value.id }
										title={ isRu || !value.nameBel ? value.name : value.nameBel }
										value={ value.id }
									>
										{ isRu || !value.nameBel ? value.name : value.nameBel }
									</Select.Option>
								)
							}) }
						</CustomSelect>
					</>
				</Form.Item>
				<Form.Item
					label={ i18n.tableHeaderName[isRu] }
					name="name"
					rules={ [
						{
							max      : 450,
							min      : 4,
							required : true
						}
					] }
				>
					<Input.TextArea
						autoSize={ {
							maxRows : 4,
							minRows : 2
						} }
						maxLength={ 500 }
						placeholder={ i18n.tableHeaderName[isRu] }
					/>
				</Form.Item>
				<Form.Item
					label={ i18n.tableHeaderNameBel[isRu] }
					name="nameBel"
					rules={ [
						{
							max      : 450,
							min      : 4,
							required : true
						}
					] }
				>
					<Input.TextArea
						autoSize={ {
							maxRows : 4,
							minRows : 2
						} }
						maxLength={ 500 }
						placeholder={ i18n.tableHeaderNameBel[isRu] }
					/>
				</Form.Item>
				<Form.Item
					label={ i18n.tableHeaderCode[isRu] }
					name="code"
					rules={ [
						{
							max      : 40,
							min      : 3,
							required : true
						}
					] }
				>
					<CustomInput
						maxLength={ 50 }
						placeholder={ i18n.tableHeaderCode[isRu] }
					/>
				</Form.Item>
				<Form.Item
					label={ i18n.tableHeaderCharacteristic[isRu] }
					name="reReportHierarchies"
					rules={ [{ required: false }] }
				>
					<>
						<CustomSelect
							allowClear
							showSearch
							defaultActiveFirstOption={ false }
							filterOption={ false }
							mode="multiple"
							notFoundContent={ null }
							placeholder={ i18n.tableHeaderCharacteristic[isRu] }
							showArrow={ false }
							value={
									values?.reReportHierarchies?.map((item) => {
										return item.id
									})
							}
							onChange={ handleChangeHierarchies }
						>
							{ reportHierarchies?.items?.map((value) => {
								return (
									<Select.Option
										key={ value.id }
										style={ {
											width: "100%"
										} }
										title={
											isRu || !value.nameBel ? value.name : value.nameBel
										}
										value={ value.id }
									>
										{ value.code }
									</Select.Option>
								)
							}) }
						</CustomSelect>
					</>
				</Form.Item>
				<Form.Item
					label={ i18n.tableHeaderDateStart[isRu] }
					name="startDate"
					rules={ [
						{
							required: true
						}
					] }
				>
					<DatePicker
						format="DD.MM.YYYY"
						placeholder={ i18n.tableHeaderDateStart[isRu] }
						style={ { width: "100%" } }
					/>
				</Form.Item>
				<Form.Item wrapperCol={ { span: 24 } }>
					<CustomButton
						htmlType="submit"
						loading={ isSending }
						type="orange"
					>
						{ i18nGlobal.save[isRu] }
					</CustomButton>
				</Form.Item>
			</Form>
		</Modal>
	)
}
export default ReportCreateUpdateForm
